import store from '../store';


const isActualFloikProd = (process.env.REACT_APP_ENVIRONMENT || '') === 'production';


export const doc360ScreenshotMinmumExtensionVersion = isActualFloikProd?0.0105:0.0111;

let extensionInstalled:any;
let currentVersion:any;
// Function to handle property changes (moved outside the hook)
const handleExtensionVersionChange = () => {
    let previousVersion = currentVersion;
    let prevExtensionInstalled = extensionInstalled;
    extensionInstalled = store.getState().onBoarding.extensionInstalled;
    currentVersion = store.getState().onBoarding.extensionVersion;
    console.log('Version has changed:', currentVersion, extensionInstalled);

    if(prevExtensionInstalled !== extensionInstalled && extensionInstalled){
        window.doc360Instance?.onMessageFromMicroApp({
            type: 'floik_app_extension_installed',
            payload: { isExtensionInstalled: extensionInstalled },
        });
    }
    
    if(previousVersion !== currentVersion){

        const supportScreenCapture = currentVersion>=doc360ScreenshotMinmumExtensionVersion;
        window.doc360Instance?.onMessageFromMicroApp({
            type: 'floik_app_extension_screencapture_support',
            payload: {
                isExtensionInstalled: extensionInstalled,
                supportScreenCapture: supportScreenCapture,
                version: currentVersion,
                requiredVersion: doc360ScreenshotMinmumExtensionVersion,
            },
        });
            
    }
};

let unsubscribeVersion:any;

unsubscribeVersion?.();

unsubscribeVersion = store.subscribe(handleExtensionVersionChange);